import type { EstateItem } from "@/shared/types/estateTypes";

const VALUE_RANGES = [
  { max: 50_000, short: "Under $50,000", long: "Under $50,000" },
  { max: 150_000, short: "$50,000 - $150,000", long: "$50,000 to $150,000" },
  { max: 500_000, short: "$150,000 - $500,000", long: "$150,000 to $500,000" },
  { max: 1_000_000, short: "$500,000 - $1M", long: "$500,000 to $1,000,000" },
  { max: Infinity, short: "Over $1M", long: "Over $1,000,000" },
];

export type ValueRange = (typeof VALUE_RANGES)[number];

export interface EstateSize {
  valuedAssetCount: number;
  propertyCount: number;
  gross: ValueRange | null;
  personalProperty: ValueRange | null;
}

const isProperty = (asset: EstateItem) => asset.category === "Properties";

const hasNumericBalance = (asset: EstateItem) => !asset.value_label;

function getValueRange(assets: EstateItem[]): ValueRange | null {
  const valued = assets.filter(hasNumericBalance);
  if (valued.length === 0) return null;
  const total = valued.reduce((sum, asset) => sum + Number(asset.balance), 0);
  return VALUE_RANGES.find((range) => total < range.max) ?? null;
}

export function getEstateSize(assets: EstateItem[]): EstateSize {
  return {
    valuedAssetCount: assets.filter(hasNumericBalance).length,
    propertyCount: assets.filter(isProperty).length,
    gross: getValueRange(assets),
    personalProperty: getValueRange(assets.filter((asset) => !isProperty(asset))),
  };
}
